import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          fontFamily: "Nunito, sans-serif",
          background: "linear-gradient(145deg,#fff 0%,#F0FDF4 40%,#ECFDF5 70%,#FEF9EE 100%)",
          gap: "16px",
          padding: "24px",
          textAlign: "center",
        }}>
          <div style={{ fontSize: "48px" }}>⚠️</div>
          <h2 style={{ color: "#1E3A5F", fontSize: "22px", margin: 0 }}>
            حدث خطأ غير متوقع
          </h2>
          <p style={{ color: "#6B7280", fontSize: "15px", margin: 0 }}>
            Something went wrong. Please reload the page.
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              marginTop: "8px",
              padding: "10px 28px",
              background: "linear-gradient(135deg,#059669,#10B981)",
              color: "#fff",
              border: "none",
              borderRadius: "12px",
              fontSize: "15px",
              cursor: "pointer",
              fontFamily: "Nunito, sans-serif",
            }}
          >
            إعادة التحميل / Reload
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
